export enum DocumentsTypes {
	FACTURE = "FACTURE",
	PHOTO = "PHOTO",
	AUTRE = "AUTRE",
}

/***************************
 ** DOCUMENT BEFORE UPLOAD **
 **************************/
type FileToUpload = {
	name: string // uuid
	custom_name: string
	gender: DocumentsTypes
}

export type DocumentToUpload = {
	bike_id: string
	account_id: string
	document: FileToUpload
	localUrl?: string | ArrayBuffer
}

/***************************
 ** DOCUMENT AFTER UPLOAD **
 **************************/
export type UploadedFile = FileToUpload & {
	url: string
}

export type UploadedDocument = {
	bike_id: string
	account_id: string
	document_data: UploadedFile
	document_id: string
	create_date: string
}
